import React from 'react';

const ConverShapeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.33325 10.7665V12.5665C7.33325 14.0665 6.73325 14.6665 5.23325 14.6665H3.43325C1.93325 14.6665 1.33325 14.0665 1.33325 12.5665V10.7665C1.33325 9.2665 1.93325 8.6665 3.43325 8.6665H5.23325C6.73325 8.6665 7.33325 9.2665 7.33325 10.7665Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M14.6667 10C14.6667 12.58 12.58 14.6667 10 14.6667L10.7 13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.33325 6.00016C1.33325 3.42016 3.41992 1.3335 5.99992 1.3335L5.29992 2.50016" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M11.6667 7.3335C13.3236 7.3335 14.6667 5.99035 14.6667 4.3335C14.6667 2.67664 13.3236 1.3335 11.6667 1.3335C10.0099 1.3335 8.66675 2.67664 8.66675 4.3335C8.66675 5.99035 10.0099 7.3335 11.6667 7.3335Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ConverShapeIcon;
